var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.475,
    height: 84.081,
    viewBox: "0 0 84.475 84.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error_loading_user_icon",
    "data-name": "error loading user icon",
    transform: "translate(0 0.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18887",
    "data-name": "Path 18887",
    d: "M0,41.849A41.849,41.849,0,1,0,41.849,0,41.854,41.854,0,0,0,0,41.849Z",
    fill: "#bce0fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(6.915 -0.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11600",
    "data-name": "Group 11600",
    transform: "translate(10.533 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24981",
    "data-name": "Path 24981",
    d: "M74.491,326.151l-41.241-.088.578-7.927a10.454,10.454,0,0,1,8.812-9.569l3.324-.521a3.468,3.468,0,0,0,2.934-3.428v-12.2H61.368v12.2a3.47,3.47,0,0,0,2.934,3.428l3.325.521a10.453,10.453,0,0,1,8.81,9.569l.012,6.507C76.52,325.61,74.491,326.151,74.491,326.151Z",
    transform: "translate(-29.769 -247.612)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24982",
    "data-name": "Path 24982",
    d: "M46.03,315.621a1.26,1.26,0,0,1,1.219-.943h5.239a5.138,5.138,0,0,0,5.138-5.138v-2.16a.916.916,0,0,1,.916-.916H61.9a3.455,3.455,0,0,1-.53-1.838V301H50.352a.727.727,0,0,1-.6-1.145l2.208-3.154a2.681,2.681,0,0,0-.619-3.7l-.056-.041a2.769,2.769,0,0,0-2.392-.424v12.092a3.468,3.468,0,0,1-2.934,3.428l-3.324.521a10.436,10.436,0,0,0-5.765,2.924l-3.561,13.7-.063.871H43.314Z",
    transform: "translate(-29.769 -247.62)",
    fill: "#ffbead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24983",
    "data-name": "Path 24983",
    d: "M75.129,411.237s-6.331,5.459-20.06,5.582-21.819-5.568-21.819-5.568l.578-7.927a10.454,10.454,0,0,1,8.812-9.569l3.324-.521a3.58,3.58,0,0,0,.68-.178,11.611,11.611,0,0,0,16.886-.036,3.485,3.485,0,0,0,.772.214l3.325.521a10.453,10.453,0,0,1,8.81,9.569l.462,6.786Z",
    transform: "translate(-29.769 -332.799)",
    fill: "#1a8cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24985",
    "data-name": "Path 24985",
    d: "M238.01,410.173l-.487-6.849A10.431,10.431,0,0,0,234.787,397c-3.585-3.894-8.037-3.237-10.005-3.919l-.023-.008c-.049-.017-.1-.035-.145-.054a11.018,11.018,0,0,1-1.13,1.066l.906.142a10.453,10.453,0,0,1,8.81,9.569l.447,6.137c.037.514.124,2.883.124,2.883l2.534-1.566Z",
    transform: "translate(-190.855 -332.799)",
    fill: "#0062f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24986",
    "data-name": "Path 24986",
    d: "M257.254,464.978a1.184,1.184,0,0,0-1.184,1.184v9.794l2.368-.8v-8.994A1.184,1.184,0,0,0,257.254,464.978Z",
    transform: "translate(-218.448 -393.732)",
    fill: "#0063f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25150",
    "data-name": "Path 25150",
    d: "M257.254,464.978a1.184,1.184,0,0,1,1.184,1.184v9.795l-2.367-.8v-8.994A1.184,1.184,0,0,1,257.254,464.978Z",
    transform: "translate(-246.448 -393.732)",
    fill: "#106ffc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24989",
    "data-name": "Path 24989",
    d: "M44.729,34.4H39.437a16.542,16.542,0,0,0-14.382,8.357,9.026,9.026,0,0,0-6.725,8.989l.457,15.809h46.3V54.764A20.363,20.363,0,0,0,44.729,34.4Z",
    transform: "translate(-17.133 -29.13)",
    fill: "#00429a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24998",
    "data-name": "Path 24998",
    d: "M39.437,34.4a16.542,16.542,0,0,0-14.382,8.357,9.026,9.026,0,0,0-6.725,8.989l.457,15.809L36.6,51.747,34.26,40.665Z",
    transform: "translate(-17.133 -29.13)",
    fill: "#013272"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11599",
    "data-name": "Group 11599",
    transform: "translate(0 18.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24990",
    "data-name": "Path 24990",
    d: "M22.235,222.811H14.079a3.546,3.546,0,0,1-3.546-3.546v-1.112a3.546,3.546,0,0,1,3.546-3.546h8.156Z",
    transform: "translate(-10.533 -199.814)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24991",
    "data-name": "Path 24991",
    d: "M258.22,222.811h8.156a3.546,3.546,0,0,0,3.546-3.546v-1.112a3.546,3.546,0,0,0-3.546-3.546H258.22Z",
    transform: "translate(-220.268 -199.814)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24992",
    "data-name": "Path 24992",
    d: "M91.1,135.605c0,11.688-11.791,18.4-18.68,18.4s-18.68-6.709-18.68-18.4c0-7.466,2.075-13.116,5.433-16.906a1.9,1.9,0,0,1,2.841.01,25.289,25.289,0,0,0,2.456,2.453,5.931,5.931,0,0,0,3.625,1.718,2.886,2.886,0,0,0,2.346-1.207,1.494,1.494,0,0,1,1.873-.483,38.287,38.287,0,0,0,13.963,3.548A4.372,4.372,0,0,1,90.3,128.1,33.2,33.2,0,0,1,91.1,135.605Z",
    transform: "translate(-47.118 -118.065)",
    fill: "#ffddcf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24993",
    "data-name": "Path 24993",
    d: "M111.883,166.213a4.357,4.357,0,0,0-2.873-3.14,34.63,34.63,0,0,1,.647,6.857c0,11.935-12.041,18.786-19.075,18.786a20.326,20.326,0,0,1-11.349-4.27c4.054,4.964,10.4,7.669,14.774,7.669,6.889,0,18.68-6.709,18.68-18.4A33.191,33.191,0,0,0,111.883,166.213Z",
    transform: "translate(-68.706 -138.086)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24994",
    "data-name": "Path 24994",
    d: "M14.367,310.789l1.219.625a19.612,19.612,0,0,0,2.65,1.539Z",
    transform: "translate(-12.054 -232.912)",
    fill: "#ffd6cc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25055",
    "data-name": "Path 25055",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(0.475 -0.383)",
    fill: "#ff88ac",
    opacity: 0.897
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11673",
    "data-name": "Group 11673",
    transform: "translate(25.881 23.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(-9.717 -7.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19272",
    "data-name": "Path 19272",
    d: "M52.837,65.325l-19.059-31.9a7.925,7.925,0,0,0-13.606,0L1.112,65.325A7.9,7.9,0,0,0,1.049,73.3a7.807,7.807,0,0,0,6.866,3.987H46.034A7.807,7.807,0,0,0,52.9,73.3,7.9,7.9,0,0,0,52.837,65.325Z",
    transform: "translate(0 -29.569)",
    fill: "#f83d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19273",
    "data-name": "Path 19273",
    d: "M281.926,73.3a7.807,7.807,0,0,1-6.866,3.987H256V29.57a7.9,7.9,0,0,1,6.8,3.86l19.059,31.9A7.9,7.9,0,0,1,281.926,73.3Z",
    transform: "translate(-229.026 -29.57)",
    fill: "#eb1154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19274",
    "data-name": "Path 19274",
    d: "M34.752,100.987A4.625,4.625,0,0,1,30.636,98.6a4.716,4.716,0,0,1,.049-4.817l19.041-31.87a4.763,4.763,0,0,1,8.182.022L76.954,93.805a4.706,4.706,0,0,1,.034,4.793,4.625,4.625,0,0,1-4.116,2.389H34.752Z",
    transform: "translate(-26.838 -56.434)",
    fill: "#ff5d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19275",
    "data-name": "Path 19275",
    d: "M275.059,100.986a4.625,4.625,0,0,0,4.116-2.389,4.706,4.706,0,0,0-.034-4.793L260.1,61.932A4.765,4.765,0,0,0,256,59.6v41.389Z",
    transform: "translate(-229.025 -56.433)",
    fill: "#f83d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19276",
    "data-name": "Path 19276",
    d: "M232.3,125.228v12.657a3.164,3.164,0,0,1-6.328,0V125.228a3.164,3.164,0,1,1,6.328,0Z",
    transform: "translate(-202.159 -112.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19277",
    "data-name": "Path 19277",
    d: "M259.164,125.228v12.657A3.173,3.173,0,0,1,256,141.049V122.064A3.174,3.174,0,0,1,259.164,125.228Z",
    transform: "translate(-229.026 -112.318)",
    fill: "#ddf0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19278",
    "data-name": "Path 19278",
    d: "M215.7,332.278a4.746,4.746,0,1,0,4.746,4.746A4.74,4.74,0,0,0,215.7,332.278Z",
    transform: "translate(-188.726 -300.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19279",
    "data-name": "Path 19279",
    d: "M260.746,337.024A4.74,4.74,0,0,1,256,341.771v-9.493A4.74,4.74,0,0,1,260.746,337.024Z",
    transform: "translate(-229.026 -300.382)",
    fill: "#ddf0ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserError);
export default __webpack_public_path__ + "static/media/user-error.47c49f59e694d6ed7e673b6efd56926a.svg";
export { ForwardRef as ReactComponent };